const DEFAULT_OSS_ORIGIN = 'https://imageoss.cnoneplus.com'

const ABSOLUTE_URL_RE = /^(?:https?:|blob:|data:)/i

function resolveOssUrl(fileUrl) {
  const value = String(fileUrl || '').trim()
  if (!value) throw new Error('缺少待下载的文件地址')
  if (ABSOLUTE_URL_RE.test(value)) return value

  const configuredOrigin = process.env.VUE_APP_OSS_BASE_URL || DEFAULT_OSS_ORIGIN
  return `${configuredOrigin.replace(/\/$/, '')}/${value.replace(/^\//, '')}`
}

function getFileName(fileUrl, fallbackName = 'aimpress-image') {
  try {
    const url = new URL(fileUrl, window.location.origin)
    const pathName = decodeURIComponent(url.pathname.split('/').pop() || '')
    if (pathName && /\.[a-z0-9]{2,8}$/i.test(pathName)) return pathName
  } catch {
    // 地址解析失败时使用安全的默认文件名。
  }
  return `${fallbackName}-${Date.now()}.jpg`
}

/** 浏览器直接从阿里云 OSS/CDN 下载，不经过业务后端。 */
export async function downloadOssFile(fileUrl, options = {}) {
  const ossUrl = resolveOssUrl(fileUrl)
  const response = await fetch(ossUrl, {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-store'
  })

  if (!response.ok) throw new Error(`OSS 文件下载失败：${response.status}`)

  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = options.fileName || getFileName(ossUrl, options.fallbackName)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
}
